export default __webpack_public_path__ + "static/media/sounds/troMultiChoiceReadingCheck.mp3";